import { useState, useRef, useEffect } from "react"
import { Button } from '@mui/material'
import React from 'react'
import DropIn from 'braintree-web-drop-in-react';
import swal from 'sweetalert';
import done from '../../../../assets/images/done.png';
import { ThreeDots } from 'react-loader-spinner'
import { getApiHeader } from 'utlis/commonfunctions';
import axios from "axios";





const SERVER_URL = process.env.REACT_APP_API_URL;

function WalletPayment({ topupAmount, setWalletPage, Data }) {
  const [defaultCard, setdefaultCard] = useState("")
  const [existingCard, setExistingCard] = useState(0)
  const instanceRef = useRef(null);
  const [paymentGateway, setPaymentGateWay] = useState(null)
  const [checkBox, setCheckBox] = useState(false)
  const [checkBoxError, setCheckBoxError] = useState(false)
  const [clientToken, setClientToken] = useState("")
  const [disabled, setDisabled] = useState(false)
  const [loading, setLoading] = useState(false);





  const styles = {
    wrapper: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(1px)",
      zIndex: 9999,
    },
  };



  useEffect(() => {
    fetchDefaultCard()
  }, [])

  const handleSuccessModalClose = () => {
    setWalletPage(false)
  }

  const handleCheckBox = () => {
    setCheckBox((prevCheckBox) => {
      const newCheckBoxState = !prevCheckBox;
      if (newCheckBoxState) {
        setCheckBoxError(false);
        setDisabled(false);
      } else {
        setCheckBoxError(true);
        setDisabled(true);
      }

      return newCheckBoxState;
    });
  }


  const fetchDefaultCard = async () => {
    try {

      const headers = await getApiHeader();
      setLoading(true)
      const response = await axios.get(`${SERVER_URL}retailer-default-card`,
        {
          headers: headers,
        }
      );
      if (response?.status === 200) {
        const paymentMethods = response?.data?.data?.payment_methods;
        if (typeof paymentMethods === "object" && !Array.isArray(paymentMethods) && paymentMethods !== null) {
          setdefaultCard(paymentMethods);
          setExistingCard(1);
          setLoading(false);
        } else {
          fetchToken();
        }
      } else {
        fetchToken();
      }

    } catch (error) {
      fetchToken();
    }
  };



  const fetchToken = async () => {
    try {
      const headers = await getApiHeader();
      setLoading(true)
      const response = await axios.get(`${SERVER_URL}wallet/client-token`, {
        headers: headers,
      });
      if (response.status === 200) {
        const clientToken = response.data.data.clientToken;
        setClientToken(clientToken);
        if (clientToken == "") {
          return
        } else {
          setTimeout(() => { setPaymentGateWay(true), setLoading(false) }, 2000)

        }
      }
      return response.status


    } catch (error) {
      setLoading(false)
      console.error('Error fetching client token:', error);
    }
  };


  const handleWalletSubmit = async () => {
    try {
      if (!checkBox) {
        setCheckBoxError(true);
        setDisabled(true);
        return;
      }

      setLoading(true)
      setDisabled(true)
      let nonce = null;

      if (existingCard === 0) {
        const paymentMethod = await instanceRef.current.requestPaymentMethod();
        nonce = paymentMethod.nonce;
      }

      const headers = await getApiHeader();
      const payload = {
        topup_amount: topupAmount,
        payment_method_nonce: nonce,
      };

      const response = await axios.post(
        `${SERVER_URL}wallet/credit-amount`,
        payload,
        { headers }
      );

      if (response.status === 200) {
        localStorage.setItem("walletAmount", response?.data?.data?.wallet_balance);
        localStorage.removeItem('SelectedWalletAmount');

        swal({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
          button: "Close"
        }).then(() => {
          handleSuccessModalClose();
        });


        setLoading(false)
      } else {
      }
    } catch (error) {
      setLoading(false)
      if (error.name === "DropinError") {
        setDisabled(false)
       // swal("Error in Payment", error.message, "warning");
      } else if (error.response?.data?.message) {
        const message = error?.response?.data.message
        swal({
          title: "error",
          text: message,
          icon: "error",
          button: "Close"
        }).then(() => {
          handleSuccessModalClose();
        });
      }

    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#e20e75"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}
      <div className="container-fluid mt-4" >
        <div className="row">
          {/* Left Section: Personal Info and Address Details */}
          <div className="col-md-8 col-lg-8">

            <div style={{ flexDirection: 'column' }} className="formbold-form-wrapper p-4 d-flex">
              <h5 className="mb-4">Retailer Info:</h5>
              {/* Personal Info Section */}
              <div className="mt-2">
                <table className="w-100  wallet-details-table ">
                  <thead>
                    <tr>
                      <th style={{ fontSize: 18 ,color:"red" }}>Name</th>
                      <th style={{ fontSize: 18 }}>Shop Name</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr >
                      <td style={{ width: 100, lineBreak: 'anywhere', fontSize: 16 }}>{Data.retailer_name}</td>
                      <td style={{ width: 100, lineBreak: 'anywhere', fontSize: 16 }}>{Data.retailer_company_name}</td>
                    </tr>
                  </tbody>
                </table>

              </div>
              <div className="mt-4">
                <table className="w-100  wallet-details-table ">
                  <thead>
                    <tr>
                      <th style={{ fontSize: 18 }}>Email ID</th>
                      <th style={{ fontSize: 18 }}>Address</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr >
                      <td style={{ width: 100, lineBreak: 'anywhere', fontSize: 16 }}>{Data.retailer_email}</td>
                      {/* <td style={{ width: 100, fontSize: 16 }}>
                        {`${Data?.retailer_company_address || ''}, `}
                        {`${Data?.retailer_address_line_1 || ''}, `}
                        {`${Data?.retailer_address_line_2 || ''}`}<br />
                        {`${Data?.retailer_suburb || ''}, ${Data?.retailer_state || ''}, ${Data?.retailer_post_code || ''}`}
                      </td> */}
                      <td style={{ width: 100, fontSize: 16 }}>
                        {[
                          Data?.retailer_company_address,
                          Data?.retailer_address_line_1,
                          Data?.retailer_address_line_2,
                        ]
                          .filter(Boolean) 
                          .join(', ')}
                        <br />
                        {[
                          Data?.retailer_suburb,
                          Data?.retailer_state,
                          Data?.retailer_post_code,
                        ]
                          .filter(Boolean)
                          .join(', ')}
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>


          </div>
          {/* Right Section: Recharge Summary */}
          <div className="col-md-4 col-lg-4">
            <div className="formbold-form-wrapper p-4">

              <div className="text-center mb-4">
                <h4
                  className=""
                  style={{
                    letterSpacing: '1px',
                    display: 'inline-block',
                  }}
                >
                  Wallet Summary
                </h4>
              </div>

              <div className="mb-3">
                <strong>Current Balance:</strong>
                <span className="ms-2">${Data.wallet_balance}</span>
              </div>
              <div className="mb-3">
                <strong>Top up Amount:</strong>
                <span className="ms-2">${topupAmount}</span>
              </div>
            </div>
          </div>


          <div style={{ textAlign: 'center' }} className="col-lg-8 mt-4 my-22">
            {/* Back Button */}

            <div className="payment-gateway-wrapper wallet-payment-wrapper formbold-form-wrapper">
              <div style={{ textAlign: 'left', marginBottom: '10px' }}>
                <button
                  style={{
                    backgroundColor: ' #C11D6C',
                    border: '2px solid #C11D6C',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '16px',
                    padding: "5px",
                    borderRadius: "10px",
                    color: "white",

                  }}
                  onClick={handleSuccessModalClose}
                >
                  <span style={{ marginRight: '8px', }}> ← </span> 
                  Back
                </button>
              </div>
              {defaultCard && existingCard === 1 ? (
                <div className="recharge-defaultCard col-lg-12">
                  <div className="recharge-defaultCardBox">
                    <p className="wallet-paying-with-card-label">Paying With Card</p>
                    <ul className="recharge-defaultCardDetails">
                      <li>
                        <img src={defaultCard.imageUrl} alt="Card Image" />
                      </li>
                      <li>
                        <span>Ending In {defaultCard.last4}</span>
                        <span>{defaultCard.cardType}</span>
                      </li>
                      <li>
                        <img src={done} alt="Done Icon" />
                      </li>
                    </ul>
                  </div>
                </div>
              ) : (
                paymentGateway && (
                  <div>
                    <DropIn
                      options={{
                        authorization: clientToken,
                      }}
                      onInstance={(instance) => (instanceRef.current = instance)}
                    />
                  </div>
                )
              )}

              <label className="check-box add-mb-accept-pay">
                <input
                  type="checkbox"
                  required=""
                  id="agreeTerms"
                  title="Please check and agree to the terms and conditions"
                  onChange={handleCheckBox}
                />
                I have read and accept the{' '}
                <a
                  target="_blank"
                  href="https://www.telsim.com.au/website-terms-conditions/"
                  rel="noopener noreferrer"
                >
                  Terms & Conditions
                </a>
                , the Acceptable Use Policy, and the{' '}
                <a
                  target="_blank"
                  href="https://www.telsim.com.au/website-privacy-policy/"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>{' '}
                for my Telsim service.
                <span className="tick"></span>
              </label>

              {checkBoxError && !checkBox && (
                <p className="error-label">
                  Please check and agree to the terms and conditions
                </p>
              )}

              <div textAlign="center" mt={4}>
                <Button
                  variant="outlined"
                  disabled={disabled}
                  sx={{
                    backgroundColor: '#C11D6C',
                    color: '#fff',
                    width: '100%',
                    '&:hover': {
                      backgroundColor: '#9C1554',
                    },
                  }}
                  onClick={handleWalletSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WalletPayment